import React, { FunctionComponent } from "react";

interface NavCategoryProp {
  name: string;
}
export const NavCategory: FunctionComponent<NavCategoryProp> = ({ name }) => (
  <div className="px-6 py-2 text-lg text-gray-100">{name}</div>
);
